module.exports = __webpack_public_path__ + "components/flag/static/square/kn-263901e8d27defb3ebfe642c84669876.svg";